export default __webpack_public_path__ + "795531d9f82acbfdcfbd9782be905bae.jpg";